// import { useState } from 'react';
// import { Link, useHistory } from 'react-router-dom';
import VRGames from '../components/projectGallery/VRGames'
// import NavBar from '../components/NavBar'
// import FooterComp from '../components/FooterComp'
import '../theme/core.css'
import { BgImage25Top } from '../styledComponents/backgroundStyled'
import { BackBorderStyled, GlobalContainer, Gap50, AboutViewText, ProfileAboutStyled, ProfileStyled, TextBorderStyledMainTitle } from '../styledComponents/globalStyled'
export default function VRGamesPage() {

    return (
        <>

            <BgImage25Top>
                <ProfileStyled>
                    <TextBorderStyledMainTitle> VR Games</TextBorderStyledMainTitle><br /><br /><br />
                    <TextBorderStyledMainTitle>I have Developed</TextBorderStyledMainTitle><br />
                </ProfileStyled>
                <BackBorderStyled />
            </BgImage25Top>

            <Gap50 />
            <ProfileAboutStyled>About my VR Journery</ProfileAboutStyled>
            <AboutViewText>Embarking on my VR journey has been a captivating exploration marked by determination and continuous effort. Despite multiple attempts, the path has not been without its challenges, and as of now, tangible results may not be apparent. However, the journey itself has been a valuable learning experience, shaping my understanding of virtual reality and fueling my commitment to overcoming obstacles. While there may not be concrete outcomes to showcase at this moment, the dedication and persistence invested in this endeavor underscore my unwavering passion for the immersive world of virtual reality.
            </AboutViewText>
            <Gap50 />

            <GlobalContainer>
                <VRGames />
            </GlobalContainer>

            {/* <FooterComp /> */}
        </>
    );
}
